<script lang="jsx">
export default {
  render() {
    // eslint-disable-next-line no-undef
    return <div profile={__PRODUCTKEY__}><router-view layout-component={this.config.mainLayoutComponent}></router-view></div>
  },
}
</script>
